import api from "@/lib/api";

const CHECKOUT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve(true);
  const existing = document.querySelector(`script[src="${CHECKOUT_SRC}"]`);
  if (existing) {
    return new Promise((resolve) => {
      existing.addEventListener("load", () => resolve(true));
      existing.addEventListener("error", () => resolve(false));
    });
  }
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = CHECKOUT_SRC;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

// Runs the full Razorpay Standard Checkout flow for a payment target
// (registration_id / booking_id / logistics_id — same shape the backend's
// PaymentIn model expects). Resolves with the verified payment record on
// success, resolves null if the user dismissed the modal, and throws an
// Error (with .response.data.detail set when it came from the backend) on
// failure so callers can reuse their existing formatError(e.response?.data?.detail)
// handling.
export async function payWithRazorpay(targetPayload, user) {
  const loaded = await loadRazorpayScript();
  if (!loaded) {
    throw new Error("Could not load the payment gateway. Check your connection and try again.");
  }

  const { data: order } = await api.post("/payments/create-order", targetPayload);

  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      name: order.name,
      description: order.description,
      order_id: order.order_id,
      prefill: {
        name: user?.full_name || "",
        email: user?.email || "",
        contact: user?.phone || "",
      },
      theme: { color: "#00F0FF" },
      modal: {
        ondismiss: () => resolve(null),
      },
      handler: async (response) => {
        try {
          const { data: verified } = await api.post("/payments/verify", {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          });
          resolve(verified);
        } catch (e) {
          reject(e);
        }
      },
    });

    rzp.on("payment.failed", (response) => {
      reject(new Error(response?.error?.description || "Payment failed"));
    });

    rzp.open();
  });
}
